var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.05585C12.392 9.05585 12.7101 9.37371 12.7101 9.766L12.5285 14.0013C12.5104 14.3844 12.2127 14.5299 11.9999 14.5299C11.7616 14.5299 11.4922 14.4043 11.4713 14.0013L11.2898 9.766C11.2898 9.37371 11.6078 9.05585 11.9999 9.05585Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 16.9422C12.2394 16.9422 12.4735 16.8459 12.6407 16.6771C12.8114 16.5083 12.9076 16.2741 12.9076 16.0345C12.9076 15.7967 12.8114 15.5625 12.6407 15.3937C12.4735 15.2249 12.2394 15.1268 11.9999 15.1268C11.7603 15.1268 11.5261 15.2249 11.3573 15.3937C11.1885 15.5625 11.0923 15.7949 11.0923 16.0345C11.0923 16.2741 11.1885 16.5083 11.3573 16.6771C11.5261 16.8459 11.7603 16.9422 11.9999 16.9422Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4841 5.71399C10.7965 5.17313 11.3736 4.84 11.9981 4.84C12.6227 4.84 13.1998 5.17313 13.5121 5.71399L19.7095 16.4483C19.8932 16.7253 19.9998 17.0578 20 17.4132C20 18.3787 19.2173 19.1617 18.2519 19.1617H5.74816C5.12361 19.1617 4.54652 18.8286 4.23414 18.2877C3.92201 17.7468 3.92193 17.0805 4.23406 16.5396L10.4841 5.71399ZM11.3109 6.19151L5.06101 17.0168C4.91936 17.2624 4.91933 17.5648 5.06101 17.8103C5.20284 18.0558 5.46474 18.2069 5.74816 18.2069H18.2511C18.6892 18.2069 19.045 17.8519 19.0452 17.4139C19.0451 17.2478 18.9949 17.0953 18.9091 16.9691L18.8993 16.9547L12.6854 6.19151C12.5435 5.94597 12.2816 5.79478 11.9981 5.79478C11.7147 5.79478 11.4527 5.94601 11.3109 6.19151Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlined);
export default __webpack_public_path__ + "static/media/warning_outlined.1b0d7673b0ba52bade636a187aa02533.svg";
export { ForwardRef as ReactComponent };